import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { TruckForm } from "@/features/dashboard/caminhoes/components/TruckForm";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/modal")({
  component: () => (
    <BaseEditCreateModal title="Criar novo Implemento de Caminhão" from="/dashboard/caminhoes/implementos/cadastrar">
      <TruckForm />
    </BaseEditCreateModal>
  )
});
